import React from "react"
import { Badge, ListGroup, ListGroupItem } from "reactstrap";
import { LogStatistics } from "../../shared/log";

const LogStatisticDetails: React.FC<{ logStatistics: LogStatistics[] }> 
    = (props) => {
    return (
        props.logStatistics && props.logStatistics.length > 0 ? (
            <ListGroup tag="div" flush>
                {props.logStatistics.map((x,i) => {
                    return (
                            <ListGroupItem key={i} className="" tag="a">
                                {x.applicationTitle} 
                                <Badge className="float-end">{x.logCount??0}</Badge>                               
                            </ListGroupItem>
                        )
                })}
            </ListGroup>
        ) : (<></>)
    );
}

export default LogStatisticDetails